import { render, staticRenderFns } from "./AgregarDireccion.vue?vue&type=template&id=0a3339af"
import script from "./AgregarDireccion.vue?vue&type=script&lang=js"
export * from "./AgregarDireccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports